import type { Metric } from '../../../../../api/initiative-client/initiative-client.type';

/**
 * Collects and sorts all unique dates from a dataset of metrics
 *
 * This function extracts all date keys from the specified unit (tasks or points)
 * across all items in the dataset, then returns them in chronological order.
 *
 * @param {Record<string, Metric>} dataset - The dataset containing metrics data, typically
 *                                          contributing_epics_over_time or contributing_teams_over_time
 * @param {'tasks' | 'points'} unit - The metric unit to extract dates from
 * @returns {string[]} An array of unique dates sorted chronologically
 */
const collectChronologicalDates = (dataset: Record<string, Metric>, unit: 'tasks' | 'points'): string[] => {
  const allDates = new Set<string>();

  Object.values(dataset).forEach((epicData) => {
    if (epicData[unit]) {
      Object.keys(epicData[unit]).forEach((date) => allDates.add(date));
    }
  });

  return Array.from(allDates).sort();
};

export { collectChronologicalDates };
